import { graphql, HttpResponse } from 'msw'
import { type EnrollmentRiskReturnData, type EnrollmentRiskReturnSubmitOutput } from '../../../models'
import { InvestmentRiskToleranceCategory } from '../../../models/enrollment/enrollment'

export const getEnrollmentRiskReturnDataMock: EnrollmentRiskReturnData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/risk-return',
  enrollmentData: {
    experimentId: 'BARBECUE',
    recommendation: {
      investment: {
        riskTolerance: {
          recommendedRiskTolerance: InvestmentRiskToleranceCategory.Balanced_3,
          allowedRiskTolerances: [
            InvestmentRiskToleranceCategory.Moderate_3,
            InvestmentRiskToleranceCategory.Moderate_4,
            InvestmentRiskToleranceCategory.Moderate_5,
            InvestmentRiskToleranceCategory.Balanced_1,
            InvestmentRiskToleranceCategory.Balanced_2,
            InvestmentRiskToleranceCategory.Balanced_3,
            InvestmentRiskToleranceCategory.Balanced_4,
            InvestmentRiskToleranceCategory.Balanced_5,
            InvestmentRiskToleranceCategory.Growth_1,
            InvestmentRiskToleranceCategory.Growth_2,
            InvestmentRiskToleranceCategory.Growth_3,
          ],
          riskTolerances: [
            {
              category: InvestmentRiskToleranceCategory.Conservative_1,
              index: 0,
              allocation: { equityPercent: 0, fixedIncomePercent: 0, cashEquivalentPercent: 100 },
            },
            {
              category: InvestmentRiskToleranceCategory.Conservative_2,
              index: 1,
              allocation: { equityPercent: 10, fixedIncomePercent: 40, cashEquivalentPercent: 50 },
            },
            {
              category: InvestmentRiskToleranceCategory.Conservative_3,
              index: 2,
              allocation: { equityPercent: 20, fixedIncomePercent: 60, cashEquivalentPercent: 20 },
            },
            {
              category: InvestmentRiskToleranceCategory.Conservative_4,
              index: 3,
              allocation: { equityPercent: 30, fixedIncomePercent: 58, cashEquivalentPercent: 12 },
            },
            {
              category: InvestmentRiskToleranceCategory.Conservative_5,
              index: 4,
              allocation: { equityPercent: 40, fixedIncomePercent: 52, cashEquivalentPercent: 8 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_1,
              index: 5,
              allocation: { equityPercent: 43, fixedIncomePercent: 49.5, cashEquivalentPercent: 7.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_2,
              index: 6,
              allocation: { equityPercent: 46, fixedIncomePercent: 47, cashEquivalentPercent: 7 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_3,
              index: 7,
              allocation: { equityPercent: 49, fixedIncomePercent: 44.5, cashEquivalentPercent: 6.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_4,
              index: 8,
              allocation: { equityPercent: 52, fixedIncomePercent: 42, cashEquivalentPercent: 6 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_5,
              index: 9,
              allocation: { equityPercent: 55, fixedIncomePercent: 39.5, cashEquivalentPercent: 5.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_1,
              index: 10,
              allocation: { equityPercent: 58, fixedIncomePercent: 37, cashEquivalentPercent: 5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_2,
              index: 11,
              allocation: { equityPercent: 61, fixedIncomePercent: 34.5, cashEquivalentPercent: 4.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_3,
              index: 12,
              allocation: { equityPercent: 64, fixedIncomePercent: 32, cashEquivalentPercent: 4 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_4,
              index: 13,
              allocation: { equityPercent: 67, fixedIncomePercent: 29.5, cashEquivalentPercent: 3.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_5,
              index: 14,
              allocation: { equityPercent: 70, fixedIncomePercent: 27, cashEquivalentPercent: 3 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_1,
              index: 15,
              allocation: { equityPercent: 73, fixedIncomePercent: 24.5, cashEquivalentPercent: 2.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_2,
              index: 16,
              allocation: { equityPercent: 76, fixedIncomePercent: 22, cashEquivalentPercent: 2 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_3,
              index: 17,
              allocation: { equityPercent: 79, fixedIncomePercent: 19.5, cashEquivalentPercent: 1.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_4,
              index: 18,
              allocation: { equityPercent: 82, fixedIncomePercent: 17, cashEquivalentPercent: 1 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_5,
              index: 19,
              allocation: { equityPercent: 85, fixedIncomePercent: 14.5, cashEquivalentPercent: 0.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_1,
              index: 20,
              allocation: { equityPercent: 88, fixedIncomePercent: 12, cashEquivalentPercent: 0 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_2,
              index: 21,
              allocation: { equityPercent: 91, fixedIncomePercent: 9, cashEquivalentPercent: 0 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_3,
              index: 22,
              allocation: { equityPercent: 94, fixedIncomePercent: 6, cashEquivalentPercent: 0 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_4,
              index: 23,
              allocation: { equityPercent: 97, fixedIncomePercent: 3, cashEquivalentPercent: 0 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_5,
              index: 24,
              allocation: { equityPercent: 100, fixedIncomePercent: 0, cashEquivalentPercent: 0 },
            },
          ],
        },
      },
    },
  },
}

export const submitEnrollmentRiskReturnDataMock: EnrollmentRiskReturnSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/equity',
  enrollmentData: {
    experimentId: 'BARBECUE',
    recommendation: {
      investment: {
        riskTolerance: {
          recommendedRiskTolerance: InvestmentRiskToleranceCategory.Balanced_3,
          allowedRiskTolerances: [
            InvestmentRiskToleranceCategory.Moderate_5,
            InvestmentRiskToleranceCategory.Balanced_1,
            InvestmentRiskToleranceCategory.Balanced_2,
            InvestmentRiskToleranceCategory.Balanced_3,
            InvestmentRiskToleranceCategory.Balanced_4,
            InvestmentRiskToleranceCategory.Balanced_5,
          ],
          riskTolerances: [
            {
              category: InvestmentRiskToleranceCategory.Conservative_1,
              index: 0,
              allocation: { equityPercent: 0, fixedIncomePercent: 0, cashEquivalentPercent: 100 },
            },
            {
              category: InvestmentRiskToleranceCategory.Conservative_2,
              index: 1,
              allocation: { equityPercent: 10, fixedIncomePercent: 40, cashEquivalentPercent: 50 },
            },
            {
              category: InvestmentRiskToleranceCategory.Conservative_3,
              index: 2,
              allocation: { equityPercent: 20, fixedIncomePercent: 60, cashEquivalentPercent: 20 },
            },
            {
              category: InvestmentRiskToleranceCategory.Conservative_4,
              index: 3,
              allocation: { equityPercent: 30, fixedIncomePercent: 58, cashEquivalentPercent: 12 },
            },
            {
              category: InvestmentRiskToleranceCategory.Conservative_5,
              index: 4,
              allocation: { equityPercent: 40, fixedIncomePercent: 52, cashEquivalentPercent: 8 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_1,
              index: 5,
              allocation: { equityPercent: 43, fixedIncomePercent: 49.5, cashEquivalentPercent: 7.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_2,
              index: 6,
              allocation: { equityPercent: 46, fixedIncomePercent: 47, cashEquivalentPercent: 7 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_3,
              index: 7,
              allocation: { equityPercent: 49, fixedIncomePercent: 44.5, cashEquivalentPercent: 6.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_4,
              index: 8,
              allocation: { equityPercent: 52, fixedIncomePercent: 42, cashEquivalentPercent: 6 },
            },
            {
              category: InvestmentRiskToleranceCategory.Moderate_5,
              index: 9,
              allocation: { equityPercent: 55, fixedIncomePercent: 39.5, cashEquivalentPercent: 5.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_1,
              index: 10,
              allocation: { equityPercent: 58, fixedIncomePercent: 37, cashEquivalentPercent: 5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_2,
              index: 11,
              allocation: { equityPercent: 61, fixedIncomePercent: 34.5, cashEquivalentPercent: 4.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_3,
              index: 12,
              allocation: { equityPercent: 64, fixedIncomePercent: 32, cashEquivalentPercent: 4 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_4,
              index: 13,
              allocation: { equityPercent: 67, fixedIncomePercent: 29.5, cashEquivalentPercent: 3.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Balanced_5,
              index: 14,
              allocation: { equityPercent: 70, fixedIncomePercent: 27, cashEquivalentPercent: 3 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_1,
              index: 15,
              allocation: { equityPercent: 73, fixedIncomePercent: 24.5, cashEquivalentPercent: 2.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_2,
              index: 16,
              allocation: { equityPercent: 76, fixedIncomePercent: 22, cashEquivalentPercent: 2 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_3,
              index: 17,
              allocation: { equityPercent: 79, fixedIncomePercent: 19.5, cashEquivalentPercent: 1.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_4,
              index: 18,
              allocation: { equityPercent: 82, fixedIncomePercent: 17, cashEquivalentPercent: 1 },
            },
            {
              category: InvestmentRiskToleranceCategory.Growth_5,
              index: 19,
              allocation: { equityPercent: 85, fixedIncomePercent: 14.5, cashEquivalentPercent: 0.5 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_1,
              index: 20,
              allocation: { equityPercent: 88, fixedIncomePercent: 12, cashEquivalentPercent: 0 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_2,
              index: 21,
              allocation: { equityPercent: 91, fixedIncomePercent: 9, cashEquivalentPercent: 0 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_3,
              index: 22,
              allocation: { equityPercent: 94, fixedIncomePercent: 6, cashEquivalentPercent: 0 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_4,
              index: 23,
              allocation: { equityPercent: 97, fixedIncomePercent: 3, cashEquivalentPercent: 0 },
            },
            {
              category: InvestmentRiskToleranceCategory.Aggressive_5,
              index: 24,
              allocation: { equityPercent: 100, fixedIncomePercent: 0, cashEquivalentPercent: 0 },
            },
          ],
        },
      },
    },
  },
}

export const mockGetEnrollmentRiskReturnData = graphql.mutation('getEnrollmentRiskReturnData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentRiskReturnDataMock } })
})

export const mockSubmitEnrollmentRiskReturnData = graphql.mutation('submitEnrollmentRiskReturnData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentRiskReturnDataMock } })
})

export const mockEnrollmentRiskReturn = [mockGetEnrollmentRiskReturnData, mockSubmitEnrollmentRiskReturnData]
